import produce from 'immer';
import create from 'zustand';

const useAdvertisingStore = create(set => ({
  advertising: {
    id: null,
    name: null,
    image: null,
    imageFilename: null,
    imageContentType: null,
    imageUrl: null,
    link: null,
    startDate: null,
    finishDate: null,
  },
  errors: {},
  set: fn => set(produce(fn)),
}));

export default useAdvertisingStore;
